import React, { useState } from "react";
import { addDataCollectApi } from "../../../service/Apis";

export default function CollectData_en() {
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim()) {
      setError("Please enter your name and email address");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError("Please enter a valid email address");
      return;
    }
    setLoading(true);
    try {
      let res = await addDataCollectApi(formData);
      res = res.data.data;
      console.log("API Response:", res);
      if (res.includes("already exist")) {
        setError("This email address already exists. Please use a different one.");
        setSubmitted(false);
        return;
      }
      const pdfUrl =
        "https://newhopepoint.s3.us-east-2.amazonaws.com/0983_33_Danielle_ID_CHI_.pdf";
      window.open(pdfUrl, "_blank");
      setSubmitted(true);
      setFormData({ name: "", email: "" });
    } catch (err) {
      console.error(err);
      setError("Submission failed. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="container-fluid d-flex align-items-center justify-content-center"
      style={{
        minHeight: "100vh",
        padding: "5px",
        background:
          "linear-gradient(rgba(30,30,30,0.55), rgba(50,40,0,0.40)), url('images/harvard.jpg') center/cover no-repeat",
      }}
    >
      <div
        className="bg-light shadow-lg p-3 rounded-4"
        style={{
          maxWidth: 450,
          width: "100%",
          opacity: 0.95,
          fontSize: "clamp(0.75rem, 1vw, 1rem)",
        }}
      >
        <h2
          className="mb-3 text-center text-warning fw-bold"
          style={{
            fontSize: "clamp(1.4rem, 2.5vw, 1.8rem)",
            letterSpacing: ".05em",
          }}
        >
          Genetic Legacy Must-Read
        </h2>

        <ul
          className="mb-3 px-2"
          style={{
            listStyle: "none",
            fontSize: "clamp(0.75rem, 1.1vw, 1rem)",
            color: "#7b6700",
            paddingLeft: 0,
            marginBottom: "10px",
          }}
        >
          <li>🏛 When you dream of building your own distinguished family</li>
          <li>😔 When you have regrets about your existing child's growth</li>
          <li>👨‍👦 When you want your own bloodline to oversee the family business</li>
          <li>🎓 When you hope for multiple children to graduate from Ivy League universities</li>
          <li>🏳️‍🌈 When you and your partner wish to have children together</li>
          <li>⏳ When you are of advanced age but still desire to welcome new life</li>
          <li>⏳ When your children are not yet ready to give you grandchildren</li>
        </ul>

        <div className="mb-2 d-flex align-items-center">
          <span
            role="img"
            aria-label="mail"
            style={{ fontSize: "1.2rem", marginRight: 6 }}
          >
            📩
          </span>
          <span
            className="text-dark fw-semibold"
            style={{
              fontSize: "clamp(0.75rem, 1vw, 0.95rem)",
              lineHeight: 1.2,
            }}
          >
            Fill in your information now to get the{" "}
            <strong>“Full Guide to Assisted Reproduction”</strong> for free
          </span>
        </div>

        {error && (
          <div
            className="alert alert-danger py-1"
            style={{ fontSize: "0.8rem", marginBottom: "8px" }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="row g-2">
            <div className="col-12">
              <label
                htmlFor="name"
                className="form-label fw-semibold"
                style={{ fontSize: "0.8rem" }}
              >
                Name:
              </label>
              <input
                type="text"
                id="name"
                className="form-control form-control-sm rounded-3"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>

            <div className="col-12">
              <label
                htmlFor="email"
                className="form-label fw-semibold"
                style={{ fontSize: "0.8rem" }}
              >
                Email:
              </label>
              <input
                type="email"
                id="email"
                className="form-control form-control-sm rounded-3"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-warning w-100 mt-3 fw-bold d-flex justify-content-center align-items-center"
            style={{
              letterSpacing: ".03em",
              height: "38px",
              fontSize: "0.85rem",
            }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Submitting...
              </>
            ) : (
              "Submit"
            )}
          </button>
        </form>

        {submitted && (
          <div
            className="alert alert-success mt-3 rounded-3 py-1"
            style={{ fontSize: "0.8rem" }}
          >
            🎉 Successfully submitted! PDF has been downloaded
          </div>
        )}
      </div>
    </div>
  );
}
